import React, { useState } from "react";
import { AnimationFileLoader } from "../../../utilis/animation-loader";
import ipfs from "../../../utilis/ipfs";
import { useAccount } from "wagmi";
import NFTMarketplace from "../../../contracts/build/NFTMarketplace.json";
import { web3, nftContract, contractAddress } from "../../../utilis/web3";
import { useNavigate } from "react-router-dom";

export default function Upload() {
  const { address } = useAccount();
  const [file, setFile] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [description, setDescription] = useState("");
  const [collection, setCollection] = useState("art_collection");
  const [supply, setSupply] = useState(1);
  const [blockchain, setBlockchain] = useState("Ethereum");

  const navigate = useNavigate();

  AnimationFileLoader();

  const handleNameChange = (event) => {
    setDisplayName(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handleCollectionChange = (event) => {
    setCollection(event.target.value);
  };

  const handleSupplyChange = (event) => {
    setSupply(event.target.value);
  };

  const handleBlockchainChange = (event) => {
    setBlockchain(event.target.value);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  const handleMint = async () => {
    if (!file) {
      console.error("Please select a file.");
      return;
    }

    try {
      // Upload file to IPFS
      const uploadResult = await ipfs.add(file);

      const tokenURI = `https://ipfs.io/ipfs/${uploadResult.path}`;

      // Prepare metadata
      const metadata = {
        name: displayName,
        description: description,
        collection: collection,
        supply: supply,
        blockchain: blockchain,
        image: tokenURI, // IPFS URL
      };

      const metadataString = JSON.stringify(metadata);

      // // Upload metadata to IPFS
      const metadataUploadResult = await ipfs.add(metadataString);

      // Generate token URI for the metadata
      const metadataTokenURI = `https://ipfs.io/ipfs/${metadataUploadResult.path}`;
      const gasEstimate = await nftContract.methods
        .mintNFT(metadataTokenURI)
        .estimateGas({ from: address });

      // Call mint regular packs function with the estimated gas
      const gasPrice = await web3.eth.getGasPrice();
      const tx = {
        from: address,
        to: contractAddress,
        gas: parseInt(gasEstimate),
        gasPrice: gasPrice,
        data: nftContract.methods.mintNFT(metadataTokenURI).encodeABI(),
      };
      console.log("Working");
      await web3.eth
        .sendTransaction(tx)
        .on("transactionHash", async function (hash) {
          console.log("Transaction Hash:", hash);
        })
        .on("confirmation", async function (confirmationNumber, receipt) {
          // Handle successful confirmation
          // You can perform additional actions here if needed
          navigate("/explore/wallet");
        })
        .on("error", function (error) {
          console.error("Error:", error);

          if (error.message.includes("User denied transaction signature")) {
            // Handle user denial
            alert(
              "Transaction was denied by the user. Please approve the transaction in MetaMask."
            );
            // You can provide additional guidance or options for the user here.
          } else {
            // Handle other errors
            // You may want to provide specific error messages based on the error code or type.
            // Example: If it's an out-of-gas error, provide instructions on adjusting gas fees.
            console.error("Transaction failed:", error);
            alert("Transaction failed.", error);
          }
        });

      // Reset form fields after minting
      setFile(null);
      setDisplayName("");
      setDescription("");
      setCollection("");
      setSupply("1");
      setBlockchain("Ethereum");
    } catch (error) {
      console.error("Error uploading to IPFS or minting NFT:", error);
    }
  };

  return (
    <>
      {/* Author */}
      <div className="author-area">
        <div
          className="author-cover"
          data-bg-img="/img/bg/author-cover.png"
        ></div>
      </div>
      {/* End Author */}

      {/* Create New Item */}
      <section className="pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              {/* Section Title */}
              <div className="section-title text-white">
                <h2>Create New Item</h2>
              </div>
              {/* End Section Title */}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {/* Form */}
              <form action="#" className="upload-form text-white">
                <div className="card mb-60">
                  <div className="card-body">
                    <div className="dropzone-wrap">
                      <h3>Image, Video, Audio or 3d Model.</h3>
                      <p>
                        File types supported: JPG, PNG, GIF, SVG, MP4, WEBM,
                        MP3, MAV, OGG, GLB, GLTF. Max size: 100 MB
                      </p>

                      {/* Dropzone Start */}
                      <div className="dropzone">
                        <input
                          type="file"
                          onChange={handleFileChange}
                          id="fileInput"
                          required
                        />
                        <span className="upload-btn" htmlFor="fileInput">
                          <img
                            src="/img/icons/plus.svg"
                            className="svg"
                            alt=""
                          />
                        </span>
                      </div>

                      {/* Dropzone End */}
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="upload-info">
                      <h3>Upload Information</h3>
                      <div className="form-group">
                        <label htmlFor="name">Display Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          onChange={handleNameChange}
                          placeholder="Item Name"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <div className="row justify-content-between">
                          <label htmlFor="description" className="col-md-5">
                            Description
                          </label>
                          <span className="info col-md-7 d-flex justify-content-md-end mb-3 mb-lg-0">
                            The Description will be include on the items details
                            page
                          </span>
                        </div>
                        <textarea
                          id="description"
                          className="form-control"
                          onChange={handleDescriptionChange}
                          placeholder="Provide detailed description of your item"
                          required
                        ></textarea>
                      </div>

                      <div className="form-group">
                        <div className="row justify-content-between">
                          <label htmlFor="collection" className="col-md-5">
                            Collection
                          </label>
                          <span className="info col-md-7 d-flex justify-content-md-end mb-3 mb-lg-0">
                            The Description will be include on the items details
                            page
                          </span>
                        </div>
                        <select
                          style={{ display: "block !important" }}
                          id="collection"
                          className="form-control"
                          value={collection}
                          onChange={handleCollectionChange}
                          required
                        >
                          <option value="art_collection">Art Collection</option>
                          <option value="music_collection">
                            Music Collection
                          </option>
                          <option value="digital_collection">
                            Digital Collection
                          </option>
                          <option value="utility_collection">
                            Utility Collection
                          </option>
                          <option value="fashion_collection">
                            Fashion Collection
                          </option>
                        </select>
                      </div>

                      <div className="form-group pt-45 mt-5">
                        <label htmlFor="supply">Supply</label>
                        <input
                          type="number"
                          className="form-control"
                          id="supply"
                          placeholder="1"
                          onChange={handleSupplyChange}
                          value={supply}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="blockchain">Blockchain</label>
                        <select
                          id="blockchain"
                          className="form-control"
                          value={blockchain}
                          onChange={handleBlockchainChange}
                          required
                        >
                          <option value="Ethereum">Ethereum</option>
                          {/* <option value="Polygon">Polygon</option> */}
                        </select>
                      </div>

                      <div className="form-group d-flex justify-content-end pt-2 mb-0">
                        <button
                          className="btn"
                          type="button"
                          onClick={handleMint}
                        >
                          <img
                            src="/img/icons/btn-save.svg"
                            alt=""
                            className="svg"
                          />{" "}
                          Create Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              {/* End Form */}
            </div>
          </div>
        </div>
      </section>
      {/* End Create New Item */}
      {/* <Footer
        footerClasses="copyright-content text-center text-white"
        textWhite={true}
        footerType="1"
      /> */}
    </>
  );
}
